import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { dsClass } from '../../common/constants/dsClasses.js';
import {
  cancelMsg,
  eppRedeemOptionTitleMsg,
  forTheCompanyMsg,
  forTheEmployeeMsg,
  redeemIsBinding,
  t,
} from '../../common/i18n/index.js';
import { EppRedeemTerminateRequestType } from '../../generated/api/models.js';
import { WizardActions } from '../WizardActions/index.js';
import { RedeemOptionDetails } from './EppRedeemOptionDetails.js';
import { RedeemOptions } from './EppRedeemOptions.js';
import { useAdminEppRedeemDialog } from './EppRedeemUtils.js';
import type { Subscription } from '../../generated/api/models.js';

import './EppRedeem.scss';

export interface EppRedeemAdminProps {
  companyName: string;
  onBackClick: () => void;
  subscription: Subscription;
}

export const EppRedeemAdmin = ({ companyName, onBackClick, subscription }: EppRedeemAdminProps) => {
  const [redeemType, setRedeemType] = useState<EppRedeemTerminateRequestType>(
    EppRedeemTerminateRequestType.COMPANY_REDEEM
  );
  const [billingAccountId, setBillingAccountId] = useState(subscription.billingAccountId);
  const [billingAccountDisplayId, setBillingAccountDisplayId] = useState(subscription.billingAccountDisplayId);
  const methods = useForm();

  const forwardClick = useAdminEppRedeemDialog(redeemType, subscription, billingAccountId!, companyName);

  return (
    <div className="of-epp-redeem">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(forwardClick)}>
          <div className={`${dsClass.PADDING_TOP_2} ${dsClass.PADDING_BOTTOM_5}`}>
            {`${t.D9NS(
              `You can redeem the device for the company or make a redemption request on behalf of the employee in case an employee has Omalaitelasku in use. The redemption price is calculated in real time. The employee can also redeem the device himself / herself from the Employee's OmaElisa at yrityksille.elisa.fi/työntekijä.`
            )} ${t.UNYV(redeemIsBinding)}`}
          </div>
          {subscription.details?.device?.omaLaiteLasku && (
            <RedeemOptions
              titleText={t.VJNB(eppRedeemOptionTitleMsg)}
              companyLabel={t.VS0Z(forTheCompanyMsg)}
              employeeLabel={t.ACGC(forTheEmployeeMsg)}
              onChange={(selectedType: EppRedeemTerminateRequestType) => setRedeemType(selectedType)}
              selectedOption={redeemType}
            />
          )}
          <RedeemOptionDetails
            billingAccountId={billingAccountId}
            billingAccountDisplayId={billingAccountDisplayId}
            subscription={subscription}
            selectedOption={redeemType}
            companyName={companyName}
            setBillingAccountId={setBillingAccountId}
            setBillingAccountDisplayId={setBillingAccountDisplayId}
          />
          <hr className={dsClass.MARGIN_VERTICAL_4} />
          <WizardActions
            forwardButtonText={t.I62A('Continue')}
            backButtonText={t.B2V1(cancelMsg)}
            onForwardClick={() => undefined}
            onBackClick={onBackClick}
          />
        </form>
      </FormProvider>
    </div>
  );
};
